import { Grid } from '@mui/material';
import SourceInstitution from './SourceInstutition/SourceInstitution';
import './AcademicHistoryStep.css';
import { useRequestdata } from '../../../useRequestData';
import Activity from '../../../../../models/Activity';
import StudentRecord, { StudentRecordActivitiy } from '../../../../../models/StudentRecord';
import SourceActivitiesTable from '../../../SourceActivitiesTable/SourceActivitiesTable';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../../shared/redux/store';
import EquivalencyRuleActivity from '../../../../../models/EquivalencyRuleActivity';
import { cleanWhiteSpaces } from '../../../../../shared/utils/commons';
import { useAppContext } from '../../../../App.Context';
import { useRequestType } from '../../../../../shared/hooks/useRequestType';

const AcademicHistoryStep: React.FC = () => {
  const {
    source_syllabus: sourceSyllabus,
    source_institution: sourceInstitution,
    targetInstitution,
    setActivities,
    student,
    optionsSourceActivities,
    sourceActivitiesNew,
    addSourceActiviyNew,
    activities,
    setContactId,
    contactId,

  } = useRequestdata({});
  const { user } = useAppContext();
  const { isInternal } = useRequestType();

  const matchSourceSyllabusData = sourceSyllabus && student?.student_records ? student?.student_records?.find((carrera: StudentRecord) => carrera.syllabus.id === sourceSyllabus.id) : null;
  const completeLastStep = sourceInstitution?.id === targetInstitution?.id;
  const filteredOptions = filterOptions(optionsSourceActivities, matchSourceSyllabusData);

  function filterOptions(optionsSourceActivities: Activity[], matchSourceSyllabusData: StudentRecord): Activity[] {
    const matchIds = matchSourceSyllabusData?.activities?.map((activity: StudentRecordActivitiy) => activity.activity.id);
    const filterOptions = matchIds && sourceInstitution?.id === targetInstitution?.id;
    return filterOptions ? optionsSourceActivities.filter((option: Activity) => matchIds.includes(option.id)) : optionsSourceActivities;
  }
  useEffect(() => {
    setContactId(contactId)
  }, []);


  // This lines between the comments will be needed in the third step in the future
  const rules = useAppSelector(state => (state.request as { rules: EquivalencyRuleActivity[] }).rules);

  const insertRuleMatch = (activity: Activity) => {
    const _item = { ...activity };
    if (targetInstitution?.id === sourceInstitution?.id) {
      _item.ruleMatch = true;
    } else {
      for (const rule of rules) {
        if (rule.input.some(inp => inp.id === activity.id)) {
          _item.ruleMatch = true;
          break;
        }
      }
    }
    return _item;
  }

  const addedActivities = activities?.filter((item) => item.new);
  const [isSourceInstitutionEqualToTargetInstitution, setIsSourceInstitutionEqualToTargetInstitution] = useState<boolean | null>(null);
  const studentRecords: StudentRecord[] = student?.student_records;

  const updateActivitiesFromStudenRecord = () => {
    const studentRecordsFiltered = studentRecords ? studentRecords.filter(record =>
      record.syllabus.id === sourceSyllabus?.id
    ) : [];

    setIsSourceInstitutionEqualToTargetInstitution(studentRecordsFiltered.length > 0 && targetInstitution?.id === sourceInstitution?.id);
    const newItemList: Activity[] = [];
    activities?.filter((item) => !item.new).map(activity => insertRuleMatch(activity))?.forEach((item) => {
      let updatedItem = null;
      studentRecordsFiltered?.forEach(recordFiltered => {
        recordFiltered.activities?.forEach(activityFromRecord => {
          if (activityFromRecord.activity.id === item.id) {
            updatedItem = {
              ...item,
              academic_transcript: {
                calification: activityFromRecord?.grade ? activityFromRecord.grade : '',
                book: cleanWhiteSpaces(activityFromRecord?.academic_transcript?.book ? activityFromRecord.academic_transcript.book : ''),
                folder: cleanWhiteSpaces(activityFromRecord?.academic_transcript?.page ? activityFromRecord.academic_transcript.page : ''),
                approval_date: activityFromRecord?.approval_date ? new Date(activityFromRecord.approval_date).toISOString().slice(0, 10) : ''
              }
            };
          }
        });
      });
      newItemList.push(updatedItem ?? item);
    });
    setActivities([...addedActivities, ...newItemList]);
  };

  useEffect(() => {
    if (matchSourceSyllabusData) updateActivitiesFromStudenRecord();
  }, [activities.length, matchSourceSyllabusData]);

  return (
    <Grid container
      direction="column"
      alignContent={'center'}
      height={'auto'}
      className='REQXXI-Step-Container-Component'
    >
      <Grid
        item
        height={'inherit'}
        width={'100%'}
        marginRight={0}
      >
        <Grid container
          justifyContent="space-between"
          height={'inherit'}
          wrap='nowrap'
          maxHeight={'600px'}
          className='REQXXI-Container-Component'>
          <Grid
            item xs={6}
            height={'inherit'}
            ml={1}
            mr={1}
            className='REQXXI-Grid-Paper'
          >
            <SourceInstitution requestData={useRequestdata({})} />
          </Grid>

          {sourceSyllabus &&
              <Grid
                item xs={6}
                ml={1}
                mr={1}
                height={'inherit'}
                className='REQXXI-Grid-Paper'
              >
                <SourceActivitiesTable
                  optionsSourceActivities={filteredOptions}
                  approvedActivities={matchSourceSyllabusData?.activities}
                  sourceActivitiesNew={sourceActivitiesNew}
                  addSourceActiviyNew={addSourceActiviyNew}
                  showAddActivity={!completeLastStep}
                  onChange={setActivities}
                  itemSelected={activities}
                  isSourceInstitutionEqualToTargetInstitution={isSourceInstitutionEqualToTargetInstitution}
                  validUser={user?.valid && isInternal}
                />
              </Grid>
          }
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AcademicHistoryStep;
